// Generated from SVG to Code Figma Plugin

export const BaseLineMusic = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.0801 17.25C15.0801 16.2835 15.8517 15.3639 16.8035 15.1961L20.4965 14.5449V16.2449C20.4965 17.239 19.7029 18.1849 18.7239 18.3575L16.8035 18.6961C15.8517 18.8639 15.0801 18.2165 15.0801 17.25Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M3.08008 19.25C3.08008 18.2835 3.85168 17.3639 4.80349 17.1961L8.00412 16.6318V18.3318C8.00412 19.3259 7.21046 20.2717 6.23146 20.4443L4.80349 20.6961C3.85168 20.8639 3.08008 20.2165 3.08008 19.25Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M8 9.022L20.5 6.0625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M8 17V6.89215C8 5.78242 8.76082 4.8174 9.8399 4.55842L17.5399 2.71042C19.0491 2.34822 20.5 3.49211 20.5 5.04415V14.8462"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
